import axios from "axios";
import { getAccessToken, setAccessToken, clearAccessToken } from "../../utils/auth";
import { clearLoginDataFunction } from "../../utils/UtilityFunctions";
import { store } from "../../Store/Store";

const api = axios.create({
  baseURL: process.env.REACT_APP_CLIENT_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

function getTokenForRequest() {
  let token = getAccessToken();
  if (token) return token;
  const loginData = store.getState().loginReducer?.loginData;
  const fromLogin =
    loginData?.token ??
    loginData?.accessToken ??
    loginData?.data?.token ??
    loginData?.data?.accessToken;
  if (fromLogin) {
    setAccessToken(fromLogin);
    return fromLogin;
  }
  return null;
}

api.interceptors.request.use(
  (config) => {
    const token = getTokenForRequest();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401 || status === "401") {
      const message = error.response?.data?.message || "";
      if (message.toLowerCase().includes("token") || message.toLowerCase().includes("access")) {
        clearAccessToken();
        clearLoginDataFunction();
        window.location.href = "/login";
        return Promise.reject(error);
      }
    }
    if (status === 403 || status === "403") {
      clearLoginDataFunction();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;